/**
 * Apple 平台统一入口
 */

// #ifdef APP-PLUS
import service from './app';
// #endif

// @ts-ignore
let apple: any = {};

// @ts-ignore
if (typeof service !== 'undefined') {
  apple = service;
}

export default apple;
